import React, { useReducer, useContext, useEffect, useState, useRef } from "react";
import Helmet from "react-helmet";
import { Context } from "../../../context/globalContext";
import { Breadcrumb, Loader } from "semantic-ui-react";
import styled from "styled-components";
import UserMembership from "../components/UserMembership";
import PaymentHistory from "../components/PaymentHistory";
import { PaymentQueries } from '../../../helpers/GraphqlQueriesLib'
import { Button } from "../../genericComponents";
import { ThemeProps } from "../../genericComponents/globalStyles";
import { RETRIEVE_STRIPE_CUSTOMER } from '../../../helpers/graphqlQueries';
import { CANCEL_STRIPE_SUBSCRIPTION } from "../../../helpers/graphqlMutations";
import { useMutation, useQuery, useSubscription } from '@apollo/client';
import RetryStripeSubscriptionPayment from "../components/RetryStripeSubscriptionPayment";
import { toast } from "react-toastify";
import { getUser } from "../../auth/services";

const initialState = { limit: 5 };

const limitReducer = (state, action) => {
  switch (action.type) {
    case 'INCREMENT':
      return { limit: state.limit + 5 };
    case 'DECREMENT': {
      if (state.limit <= 5) {
        return state;
      } else {
        return { limit: state.limit - 5 };
      }
    }
    default: throw new Error();
  }
}

export default function UserMembershipPage() {
  const [loadingUser, setLoadingUser] = useState(true);
  const paymentDataJson = useRef()
  const [limitPayments, dispatch] = useReducer(limitReducer, initialState)
  const {graphQLClient, state: { user: userProfile }, dispatch: {setUser} } = useContext(Context);

  const { loading: loadingPayments,data: paymentData } = useSubscription(
    PaymentQueries.SUBS_PAYMENTS,
    { variables: { userEmail: userProfile.email, limitPayments: limitPayments.limit },
    onSubscriptionData
  }
  );
  const [cancelSubscriptionMutation] = useMutation(CANCEL_STRIPE_SUBSCRIPTION,{onCompleted:cancelCompleted,onError:cancelError});
  const { data:stripeCustomer, refetch:refetchStripeCustomer} = useQuery(RETRIEVE_STRIPE_CUSTOMER,{variables:{customerId:userProfile.stripe_customer_id}});
  const stripeSubscription = stripeCustomer?.retrieveStripeCustomer?.result?.subscriptions?.data[0];

  useEffect(() => {
    if (userProfile) {
      setLoadingUser(false)
    }
  }, [userProfile]);

  function onSubscriptionData(data) {
    if(JSON.stringify(data?.subscriptionData?.data?.payments)!==paymentDataJson.current&&!paymentDataJson.current){
      refetchStripeCustomer();
    }
    paymentDataJson.current=JSON.stringify(data?.subscriptionData?.data?.payments)
  }

  async function cancelCompleted(data) {
    toast.info('Subscription canceled')
    refetchStripeCustomer();
    const { userAccount } = await getUser(graphQLClient, userProfile.email || "");
    if(userAccount)setUser({...userProfile,userAccount})
  }
  function cancelError(error) {
    toast.error('An error ocurred, please contact support')
    refetchStripeCustomer();
    console.log(error)
  }
  

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{userProfile.name||''}</title>
      </Helmet>
      {(loadingUser || loadingPayments) ? (
        <Loader active size={"massive"} />
      ) : (
        <section id="page_content">
          <BodyContainer>
            <Breadcrumb icon="right angle">
              <Breadcrumb.Section link>Home</Breadcrumb.Section>
              <Breadcrumb.Divider icon="right chevron" />
              <Breadcrumb.Section active>
                {userProfile.name}
              </Breadcrumb.Section>
              <Breadcrumb.Divider icon="right chevron" />
              <Breadcrumb.Section active>
                {'Membership'}
              </Breadcrumb.Section>
            </Breadcrumb>
            <UserMembership user={userProfile} stripeSubscription={stripeSubscription} cancelSubscription={cancelSubscriptionMutation} />
            {(stripeSubscription?.status==='incomplete'||stripeSubscription?.status==='past_due'||stripeSubscription?.status==='unpaid')&&(
              <RetryStripeSubscriptionPayment stripeSubscription={stripeSubscription}/>
            )}
            <PaymentHistory paymentHistory={paymentData} />
            <ButtonContainer>
              <OperatorButton onClick={() => dispatch({ type: 'INCREMENT' })}>+</OperatorButton>
              <OperatorButton onClick={() => dispatch({ type: 'DECREMENT' })}>-</OperatorButton>
            </ButtonContainer>
          </BodyContainer>
        </section>
      )}
    </>
  );
}

const BodyContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 16px 20px;
`;

const ButtonContainer = styled.div`
  display:flex;
  flex-direction:row;
  justify-content:flex-end;
  width:80%;
  margin:0px auto;
`;

const OperatorButton = styled(Button)`
  background: ${ThemeProps.color.softPurple};
  font-size:100%;
  font-weight:bold;
  padding:8px;
  margin:5px;
`

